<template>
    <div class="footer__slogan">
        <span class="line"></span>
        <h4>Your Routine with {{ appName }}</h4>
    </div>
</template>

<script>
export default {
    data() {
        return {
            appName: import.meta.env.VITE_APPNAME
        };
    },
}
</script>
